import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLeftLong } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import LabTestsTable from "./LabTestsTable";
import React, {useContext} from "react";
import InitContext from "../pages/InitContext";

const LabTests = () => {
  const { t } = useTranslation();
  const context = useContext(InitContext);

  return (
    <div className="w3-display-container content-container content-container-full">
      <div className="medication-view">
        <div style={{ width: '100%', textAlign: 'right', paddingRight: "20px" }}>
          <label>{t("username")}: {context?.patient?.login}, {t("role")}: {t("patient").toLowerCase()}</label>
        </div>
        <div className="form-display-drugs medication-content">
          <div className="w3-panel w3-card-4 record-panel">
            <LabTestsTable>
              <h2>{t("laboratory_test_data")}</h2>
            </LabTestsTable>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LabTests;
